import { render } from "./Balochistan.vue?vue&type=template&id=47fa254e&scoped=true"
const script = {}

import "./Balochistan.vue?vue&type=style&index=0&id=47fa254e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47fa254e"]])

export default __exports__